import React, { useState, useEffect } from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import CustomText, {
  getFontSize,
  getFontWeight,
} from "../../../../components/CustomText";
import Image from "../../../../../assets";
import { Helmet } from "react-helmet";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import AuthManager from "../../../../../utils/AuthManager";
import _ from "lodash";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  imageStyle: {
    width: 200,
    height: 200,
  },
  titleTextStyle: {
    fontSize: 21,
    ...getFontWeight("800"),
    color: "#2c3034",
    lineHeight: 1.37,
  },
  highLightedTextStyle: {
    color: "#00B4AF",
    fontFamily: "Muli",
    ...getFontSize("small"),
    ...getFontWeight("600"),
    "&:hover": {
      cursor: "pointer",
      textDecoration: "underline",
    },
  },
  highLightedTextStyleV2: {
    color: "#FEC31A",
    fontFamily: "Muli",
    ...getFontSize("small"),
    ...getFontWeight("600"),
    "&:hover": {
      cursor: "pointer",
      textDecoration: "underline",
    },
  },
  descTextStyle: {
    ...getFontSize("small"),
    ...getFontWeight("600"),
    color: "#818181",
  },
}));

const SingPass = ({
  sinpassClientId,
  singpassRedirectUrl,
  enableMaintenance,
}) => {
  const classes = useStyles();
  const theme = useTheme();
  const [doInit, setDoInit] = React.useState(false);
  // const matchesMD = useMediaQuery(theme.breakpoints.down("md"));
  // const matchesSM = useMediaQuery(theme.breakpoints.down("sm"));
  const matchesXS = useMediaQuery(theme.breakpoints.down("xs"));

  const getUrlVars = () => {
    var vars = {};
    var parts = window.location.href.replace(
      /[?&]+([^=&]+)=([^&]*)/gi,
      function (m, key, value) {
        vars[key] = value;
      }
    );
    return vars;
  };

  async function init() {
    var spState = getUrlVars()["SPState"];
    //console.log("spState", typeof spState);
    const authParamsSupplier = async () => {
      return {
        state: _.isEmpty(spState)
          ? ("" + Math.random() * 1000000000000000 + "").slice(0, 15)
          : spState,
        nonce: ("" + Math.random() * 1000000000000000 + "").slice(0, 15),
      };
    };
    const onError = (errorId, message) => {
      console.log(`onError. errorId:${errorId} message:${message}`);
    };

    const initAuthSessionResponse = setTimeout(function () {
      window.NDI.initAuthSession(
        "ndi-qr",
        {
          clientId: process.env.REACT_APP_SING_PASS_CLIENT_ID,
          redirectUri: process.env.REACT_APP_SING_PASS_REDIRECT_URL,
          scope: "openid",
          responseType: "code",
        },
        authParamsSupplier,
        onError
      );
    });

    console.log("initAuthSession: ", initAuthSessionResponse);
  }

  // useEffect(() => {
  //   const script = document.createElement("script");

  //   script.src = process.env.REACT_APP_SING_PASS_SCRIPT_SRC;

  //   script.async = true;
  //   document.body.appendChild(script);

  //   return () => {
  //     document.body.removeChild(script);
  //   };
  // }, []);

  // useEffect(() => {
  //   console.log("a")
  //   if (doInit === false) {
  //     if(sinpassClientId !== (null) && singpassRedirectUrl !== (null) ){
  //       console.log("a")
  //       init();
  //     }

  //   }
  // }, []);
  // useEffect(() => {
  //   if (sinpassClientId !== false && singpassRedirectUrl !== false) {
  //     if (doInit === false) {
  //       //console.log("a");
  //       setTimeout(function () {
  //         init();

  //       }, 200);
  //     }
  //   }
  // });

  useEffect(() => {
    setTimeout(function () {
      init();
    }, 1500);
  }, []);

  const onClickFindOutMore = () => {
    window.open(
      "https://app.singpass.gov.sg/?utm_source=etiqa_insurance&utm_medium=web&utm_campaign=spm-login"
    );
  };

  return (
    <div className={classes.root}>
      {/* <img src={Image.qrCode} /> */}
      <div id="ndi-qr"></div>
      {/* {!matchesXS ? (
        <div style={{ marginTop: 10 }}>
          <CustomText design={classes.titleTextStyle}>
            Scan with SingPass
          </CustomText>
          <CustomText design={classes.titleTextStyle}>
            Mobile App to Login
          </CustomText>
        </div>
      ) : (
        false
      )} */}
      {enableMaintenance === true ? (
        false
      ) : !matchesXS ? (
        <div style={{ marginTop: 10 }}>
          <CustomText design={classes.descTextStyle} component="div">
            Don't have SingPass Mobile?{" "}
            <CustomText
              display={"inline"}
              design={classes.highLightedTextStyleV2}
              onClick={onClickFindOutMore}
            >
              Find out more
            </CustomText>
          </CustomText>
        </div>
      ) : (
        <div style={{ marginTop: "5%", paddingRight: 17 }}>
          <CustomText design={classes.descTextStyle} component="div">
            Don't have SingPass Mobile?{" "}
            <CustomText
              display={"inline"}
              design={classes.highLightedTextStyleV2}
              onClick={onClickFindOutMore}
            >
              Find out more
            </CustomText>
          </CustomText>
        </div>
      )}

      {/* <div class="col-md-6 login-qr-section">
        <div class="login-qr-form">
          <div class="recommendedTextWarning">
            <p>
              There's a scheduled SingPass maintenance from 05 Jan 2020 00:00 to
              05 Jan 2020 08:00. We apologise for the inconvenience caused.
            </p>
          </div>
          
          <span class="terms" style="font-size:14px; white-space:nowrap;">
            Don't have SingPass Mobile?{" "}
            <a
              href="https://go.gov.sg/spm-etiqa"
              target="_blank"
              style="font-size:14px;color:darkturquoise"
            >
              Find out more
            </a>
          </span>
        </div>
      </div> */}
    </div>
  );
};

export default SingPass;
